import { KeywordButtonType } from "@components/Button/utils/types";
import KeywordFilter from "@components/KeywordFilter";
import { KeywordType } from "@components/KeywordFilter/utils/types";
import { useWindowSize } from "@hooks/useWindowSize";
import { Tag } from "@typings/Cue";

type CampaignTemplateHeaderProps = {
  /** Image url to display the logo on header of campaign tempplate */
  logo: string;
  /** Data required for keyword filter component */
  feedTag: Tag;
};

/** Component to render header on campaign template */
const CampaignTemplateHeader = ({
  logo,
  feedTag,
}: CampaignTemplateHeaderProps): React.ReactElement => {
  const { isScreenMD } = useWindowSize();

  return (
    <div
      className="mb-6 flex items-center justify-between border-b border-gray-850 pb-3 md:justify-start"
      data-testid="campaign-template-header-component"
    >
      {logo ? (
        <img
          src={logo}
          width={isScreenMD ? 150 : 105}
          height={isScreenMD ? 60 : 42}
          alt={feedTag.name}
        />
      ) : null}

      <KeywordFilter
        keywordButtonType={KeywordButtonType.version2}
        tag={feedTag}
        className="inline-block w-full"
        tagClassName="border-none !font-playfair !text-6xl md:!text-8xl !p-0 text-gray-850 !uppercase !text-left !text-normal"
        disableTooltip
        keywordType={logo ? KeywordType.noTag : KeywordType.listing}
        buttonClassName={"ml-4"}
        isLinkenabled={false}
        testId="keyword-filter"
      />
    </div>
  );
};

export default CampaignTemplateHeader;
